import { h } from 'preact';
import { Tooltip } from '../Tooltip';
import { Button } from '../Button';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Tooltip',
  category: '🪟 Modais & Overlay',
  description: 'Tooltip hover com 3 posições (top, bottom, right)',
  usedIn: ['AgentesPage', 'Integrations', 'ChatHubPage'],
  example: () => (
    <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
      <Tooltip text="Dica no topo" position="top">
        <Button variant="ghost" size="sm">Hover aqui (top)</Button>
      </Tooltip>
      <Tooltip text="Dica embaixo" position="bottom">
        <Button variant="ghost" size="sm">Hover aqui (bottom)</Button>
      </Tooltip>
      <Tooltip text="Dica na direita" position="right">
        <Button variant="ghost" size="sm">Hover aqui (right)</Button>
      </Tooltip>
    </div>
  ),
};
